/** エリアなし選択肢の sentinel 値 */
export const UNSPECIFIED_SITE_ID = -1
